import { invert } from "lodash";

export const colorMap = {
  red: "#d0011b",
  peach: "#ff9b7b",
  orange: "#e79102",
  yellow: "#f5e309",
  mint: "#a1eda3",
  apple: "#73c619",
  lightTeal: "#2fc286",
  darkTeal: "#0a7b75",
  lightBlue: "#89e4ff",
  denim: "#6592c7",
  midBlue: "#00a2ef",
  darkBlue: "#004fef",
  darkPurple: "#6434ff",
  lightPurple: "#b59dff",
  pastelPink: "#f89dff",
  fuschia: "#bc28c8",
  lightPink: "#ff629e",
  darkPink: "#fe3d5a",
  grey: "#8c8c8c",
  mono: "#ffffff",
  deepPurple500: "#673AB7",
  lightGreen500: "#8BC34A",
  lime500: "#CDDC39",
  brown500: "#795548",
  red200: "#EF9A9A",
  red300: "#E57373",
  red500: "#F44336",
  red700: "#D32F2F",
  red900: "#B71C1C",
  red200A: "#FF5252",
  red400A: "#FF1744",
  red700A: "#D50000",
  pink200: "#F48FB1",
  pink300: "#F06292",
  pink500: "#E91E63",
  pink700: "#C2185B",
  pink900: "#880E4F",
  pink200A: "#FF4081",
  pink400A: "#F50057",
  pink700A: "#C51162",
  purple200: "#CE93D8",
  purple300: "#BA68C8",
  purple500: "#9C27B0",
  purple700: "#7B1FA2",
  purple900: "#4A148C",
  purple200A: "#E040FB",
  purple400A: "#D500F9",
  purple700A: "#AA00FF",
  indigo200: "#9FA8DA",
  indigo300: "#7986CB",
  indigo500: "#3F51B5",
  indigo700: "#303F9F",
  indigo900: "#1A237E",
  indigo200A: "#536DFE",
  indigo400A: "#3D5AFE",
  indigo700A: "#304FFE",
  blue200: "#90CAF9",
  blue300: "#64B5F6",
  blue500: "#2196F3",
  blue700: "#1976D2",
  blue900: "#0D47A1",
  blue200A: "#448AFF",
  blue400A: "#2979FF",
  blue700A: "#2962FF",
  teal200: "#80CBC4",
  teal300: "#4DB6AC",
  teal500: "#009688",
  teal700: "#00796B",
  teal900: "#004D40",
  teal200A: "#64FFDA",
  teal400A: "#1DE9B6",
  teal700A: "#00BFA5",
  green200: "#A5D6A7",
  green300: "#81C784",
  green500: "#4CAF50",
  green700: "#388E3C",
  green900: "#1B5E20",
  green200A: "#69F0AE",
  green400A: "#00E676",
  green700A: "#00C853",
  yellow200: "#FFF59D",
  yellow300: "#FFF176",
  yellow500: "#FFEB3B",
  yellow700: "#FBC02D",
  yellow900: "#F57F17",
  yellow200A: "#FFFF00",
  yellow400A: "#FFEA00",
  yellow700A: "#FFD600",
  deepOrange200: "#FFAB91",
  deepOrange300: "#FF8A65",
  deepOrange500: "#FF5722",
  deepOrange700: "#E64A19",
  deepOrange900: "#BF360C",
  deepOrange200A: "#FF6E40",
  deepOrange400A: "#FF3D00",
  deepOrange700A: "#DD2C00",
  grey300: "#E0E0E0",
  grey500: "#9E9E9E",
  grey700: "#616161",
  grey900: "#212121",
  blueGrey300: "#90A4AE",
  blueGrey500: "#607D8B",
  blueGrey700: "#455A64",
  blueGrey900: "#263238",
  iconRed: "#fe3d5a",
  iconOrange: "#ff7962",
  iconGreen: "#2e9793",
  iconPurple: "#7088e6",
  iconYellow: "#f5e309",
  iconBlue: "#69B8FA",
  iconMono: "#ffffff",
  iconInverse: "#000000",
  iconBold: "#ffffff",
  pureMaroon: "#800000",
  pureCrimson: "#db133b",
  pureRed: "#ff0000",
  pureOrange: "#e16e31",
  pureOlive: "#808000",
  pureGreen: "#008000",
  pureTeal: "#008080",
  pureLightGreen: "#2ec994",
  pureLime: "#00ff00",
  pureNavy: "#000080",
  pureBlue: "#0000ff",
  pureCyan: "#00ffff",
  pureGold: "#ffd600",
  pureYellow: "#ffff00",
  pureLightYellow: "#fffacd",
  purePurple: "#800080",
  pureLilac: "#8373c0",
  pureMagenta: "#ff00ff",
  pureLavendar: "#e6e6f9",
  purePink: "#ffbfca",
  pureBlack: "#000000",
  pureGray: "#808080",
  pureSilver: "#bfbfbf",
  pureWhite: "#ffffff",
  // Legacy dupe of iconMono. Needs to be kept in to avoid crashing files that include it.
  iconWhite: "#ffffff"
};

export const colorMapHexLookup = invert(colorMap);

export default [
  "red",
  "peach",
  "orange",
  "yellow",
  "mint",
  "apple",
  "lightTeal",
  "darkTeal",
  "lightBlue",
  "denim",
  "midBlue",
  "darkBlue",
  "darkPurple",
  "lightPurple",
  "pastelPink",
  "fuschia",
  "lightPink",
  "darkPink",
  "grey",
  "mono",
  "deepPurple500",
  "lightGreen500",
  "lime500",
  "brown500",
  "red200",
  "red300",
  "red500",
  "red700",
  "red900",
  "red200A",
  "red400A",
  "red700A",
  "pink200",
  "pink300",
  "pink500",
  "pink700",
  "pink900",
  "pink200A",
  "pink400A",
  "pink700A",
  "purple200",
  "purple300",
  "purple500",
  "purple700",
  "purple900",
  "purple200A",
  "purple400A",
  "purple700A",
  "indigo200",
  "indigo300",
  "indigo500",
  "indigo700",
  "indigo900",
  "indigo200A",
  "indigo400A",
  "indigo700A",
  "blue200",
  "blue300",
  "blue500",
  "blue700",
  "blue900",
  "blue200A",
  "blue400A",
  "blue700A",
  "teal200",
  "teal300",
  "teal500",
  "teal700",
  "teal900",
  "teal200A",
  "teal400A",
  "teal700A",
  "green200",
  "green300",
  "green500",
  "green700",
  "green900",
  "green200A",
  "green400A",
  "green700A",
  "yellow200",
  "yellow300",
  "yellow500",
  "yellow700",
  "yellow900",
  "yellow200A",
  "yellow400A",
  "yellow700A",
  "deepOrange200",
  "deepOrange300",
  "deepOrange500",
  "deepOrange700",
  "deepOrange900",
  "deepOrange200A",
  "deepOrange400A",
  "deepOrange700A",
  "grey300",
  "grey500",
  "grey700",
  "grey900",
  "blueGrey300",
  "blueGrey500",
  "blueGrey700",
  "blueGrey900",
  "pureMaroon",
  "pureCrimson",
  "pureRed",
  "pureOrange",
  "pureOlive",
  "pureGreen",
  "pureTeal",
  "pureLightGreen",
  "pureLime",
  "pureNavy",
  "pureBlue",
  "pureCyan",
  "pureGold",
  "pureYellow",
  "pureLightYellow",
  "purePurple",
  "pureLilac",
  "pureMagenta",
  "pureLavendar",
  "purePink",
  "pureBlack",
  "pureGray",
  "pureSilver",
  "pureWhite",
  // Legacy dupe of iconMono. Needs to be kept in to avoid crashing files that include it.
  "iconWhite"
];
